import { createSelector } from 'reselect';
import { evaluateAuthRequireAll } from '../../authorizations/auth-helpers';
import { AUTHORIZATIONS } from '../../authorizations/authorizations';
const validUserAuths = [AUTHORIZATIONS.CAN_LOGIN];

export const userAccountSelector = (state) => state.account;

export const accountAuthorizationsSelector = createSelector(
    userAccountSelector,
    (userAccount) => userAccount?.authorizations
);

export const passwordTokenSelector = createSelector(
    userAccountSelector,
    (userAccount) => userAccount.resetPasswordToken
);

export const isValidUser = createSelector(userAccountSelector, (userAccount) => {
    return evaluateAuthRequireAll(validUserAuths, userAccount?.authorizations);
});

export const emailSelector = createSelector(userAccountSelector, (userAccount) => {
    return userAccount.username;
});
